
/* eslint-disable @typescript-eslint/camelcase */
import { Options,  mixins } from "vue-class-component";
import {
  SearchFlight,
  CargoDetailStt,
  DimensionPerKoliDetail
} from "@/domain/entities/Cargo";
import {
  formatDateNormal,
  commaDecimalToDecimal,
  firstCapitalize,
  dateTimePayload,
  formatDate,
  getDataSessionStorage,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { capitalize } from "vue";
import { OptionsClass, ModalMessageEntities } from "@/domain/entities/MainApp";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import {
  FlightPlanForECargo,
  AddBagOrStt,
  CheckAvailableRequest,
  CalculateVolumeApiRequest,
  CalculateVolumeRequest
} from "@/data/payload/api/CargoApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { flags } from "@/feature-flags";
import { GTMBookingCargoEvent } from "@/app/infrastructures/misc/gtm-event/custom-events/booking-cargo-event";
import { gtmCargoData } from "../../../modules/gtm";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import OutGoingMixins from "@/app/ui/views/out-going-shipment/out-going-mixin";
import {
  getConfigDimensionDivider,
  handleFailedBookingNavigation,
  getConfigIsminimumVolumePerPiece
} from "../../../modules/cargo-module";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { useCargo } from "../../composables/cargo";

const { checkEligible } = useCargo();

@Options({
  props: {
    dataFlight: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    totalFlight: {
      type: Number,
      required: true
    }
  }
})
export default class ScheduleCardV2 extends mixins(OutGoingMixins) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  withPrint = false;
  withPrintLabel = false;
  countSuccess = 0;
  countFailed = 0;
  formatDateNormal = formatDateNormal;
  props: any = this.$props;

  mounted() {
    this.onResetSelected();
  }

  get flightData(): SearchFlight {
    return this.props.dataFlight;
  }

  get totalFlight() {
    return this.props.totalFlight;
  }

  get formBooking() {
    return CargoController.form;
  }

  get partnerName() {
    return capitalize(this.dataProfile.account_type_detail.company_name);
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get typeUser() {
    return this.dataProfile.normalizedTypeUser;
  }

  // origin city
  get originCity(): OptionsClass {
    const detailDistrict = LocationController.districtDetail;
    return new OptionsClass({
      name: `${detailDistrict.cityCode} - ${firstCapitalize(
        detailDistrict.cityName.toLowerCase()
      )}`,
      code: detailDistrict.cityCode
    });
  }
  get destinationCity(): OptionsClass {
    return CargoController.destinationCity;
  }

  get isRtc() {
    return (
      ReadyToCargoController.flowBooking === "rtc-process" ||
      ReadyToCargoController.flowBooking === "rtc-edit"
    );
  }

  get sttResult(): CargoDetailStt[] {
    return CargoController.sttResultFinal;
  }

  get totalStt() {
    return this.sttResult.reduce((prev, curr: any) => {
      if (curr?.sttDetails) return prev + curr.sttDetails.length
      return prev + 1
    }, 0)
  }

  get totalPieces() {
    return CargoController.totalSttPieces;
  }

  get detailDistrict() {
    return LocationController.districtDetail;
  }

  get rcId(): number {
    return Number(this.$route.query.rcId);
  }

  get formDetailPieces() {
    return CargoController.formDetailPieces;
  }

  get isHaveBeenSubmitDetailPieces() {
    return CargoController.isHaveBeenSubmitDetailPieces;
  }

  get isValidDimension(): boolean {
    return CargoController.dimensionPerKoliData.dimensionPieces.every(
      e => e.sttOrBag
    )
  }
  get mappingDetailPieces() {
    const isRtcOrRebooking = this.isRtc && this.formBooking.cargoType === "plane";
    const dimensionsPlaneAuto =
      !flags.feature_hide_dimension_koli.isEnabled() &&
      this.isValidDimension &&
      (this.isPlaneAuto || isRtcOrRebooking);

    if (dimensionsPlaneAuto) {
      return this.dimensionV2Payload;
    }

    return this.dimensionV1Payload;
  }
  get dimensionV1Payload() {
    return this.formDetailPieces.dimensionPieces.map((item: any) => {
      return {
        pieces: !this.isHaveBeenSubmitDetailPieces
          ? +this.formBooking.actualTotalSTTPieces
          : +item.pieces,
        length: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.length
          : item.length,
        width: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.width
          : item.width,
        height: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.height
          : item.height,
        "gross_weight": item.sttOrBag ? item.grossWeight : undefined,
        "volume_weight": item.sttOrBag ? item.volumeWeight : undefined,
        "stt_or_bag": item.sttOrBag
      };
    });
  }
  get dimensionV2Payload() {
    return CargoController.dimensionPerKoliData.dimensionPieces.map(
      (item: DimensionPerKoliDetail) => ({
        stt_or_bag: item.sttOrBag,
        pieces: item.totalPieces,
        length: item.sttPieceLength,
        width: item.sttPieceWidth,
        height: item.sttPieceHeight,
        gross_weight: item.sttPieceGrossWeight,
        volume_weight: item.sttPieceVolumeWeight
      })
    );
  }

  get actualCargoVolumeWeightPayload() {
    return this.getActualCargoWeight(
      CargoController.dimensionPerKoliData.actualVolumeWeight,
      this.formBooking.actualTotalCargoVolumeWeight
    );
  }

  get isRTC() {
    return (
      ReadyToCargoController.flowBooking.includes("rtc") || this.isRebooking
    );
  }

  private getActualCargoWeight(dimensionWeight: number, totalWeight: string) {
    const isRtcOrRebooking =
      this.isRTC && this.formBooking.cargoType === "plane";
    const dimensionsPlaneAuto =
      !flags.feature_hide_dimension_koli.isEnabled() &&
      this.isValidDimension &&
      (this.isPlaneAuto || isRtcOrRebooking);

    return dimensionsPlaneAuto
      ? Number(dimensionWeight.toFixed(2))
      : commaDecimalToDecimal(totalWeight);
  }

  get dataDetailRetryCargo() {
    return CargoController.cargoDetailData;
  }

  get detail() {
    return ReadyToCargoController.readyToCargoDetail;
  }

  get flowBooking() {
    return ReadyToCargoController.flowBooking;
  }

  get isRebooking() {
    return this.flowBooking === "rebooking" && this.$route.query.rcId;
  }

  get isFromRebookingRTC() {
    return CargoController.isRebookingFromRTC;
  }

  get timestampBooking() {
    return CargoController.timestampBooking;
  }

  get eventName() {
    return ReadyToCargoController.eventName;
  }

  get isPlaneAuto() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus === "auto"
    );
  }

  get progress(): number {
    return CargoController.progressValue;
  }

  get withPrintCutOff() {
    return CargoController.withPrintCutOff;
  }

  get withPrintCutOffLabel() {
    return CargoController.withPrintCutOffLabel;
  }

  get cutOffTime() {
    return {
      hours: ReadyToCargoController.readyToCargoDetail.cutOffTime?.split(
        ":"
      )[0],
      minutes: ReadyToCargoController.readyToCargoDetail.cutOffTime?.split(
        ":"
      )[1]
    };
  }

  get isEditCutoff() {
    return this.isAllowEditCutoff;
  }

  get isAllowEditCutoff() {
    const isEditRtcCutoff =
      ReadyToCargoController.flowBooking === "rtc-edit" &&
      this.isPlaneAuto &&
      this.cutOffTime.hours !== undefined &&
      this.cutOffTime.minutes !== undefined;
    return isEditRtcCutoff;
  }

  get payloadBagNoOnly() {
    return JSON.parse(getDataSessionStorage("cargo-bag") || "[]")
      .map((item: any) =>
        item.isFromRebooking ? null : new AddBagOrStt(item.baggingNumber)
      )
      .filter((items: any) => items != null);
  }

  get payloadSttNoOnly() {
    return JSON.parse(getDataSessionStorage("cargo") || "[]")
      .filter(
        (item: any) =>
          !JSON.parse(
            getDataSessionStorage("cargo-bag") || "[]"
          ).find((bag: any) => JSON.stringify(bag).includes(item.sttNumber)) ||
          JSON.parse(getDataSessionStorage("cargo-bag") || "[]").find(
            (itemBag: any) => item.isFromRebooking == itemBag.isFromRebooking // add validation to check on cargo-bag that come from rebooking
          )
      )
      .map((item: any) => {
        if (item.sttDetails) {
          return item.sttDetails.map(
            (item: any) => new AddBagOrStt(undefined, item.sttNumber)
          );
        } else {
          return new AddBagOrStt(undefined, item.sttNumber);
        }
      })
      .flat();
  }

  get payloadOriginAirportCode() {
    return this._mapPayloadFlightPlanForECargo()[0].flight_origin;
  }
  get payloadDestinationAirportCode() {
    const lastIndex = this._mapPayloadFlightPlanForECargo().length - 1;
    return this._mapPayloadFlightPlanForECargo()[lastIndex].flight_destination;
  }

  get payloadDepartureDate() {
    return this.flightData.departureDate || this.formBooking.estDepartureDate;
  }

  get payloadArrivalDate() {
    return this.flightData.arrivalDate || this.formBooking.estArrivalDate;
  }

  get payloadOverCutOffLimit() {
    const cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    return CargoController.isOverCutOffTime || this.detail.isMoreThanCutOffTime || cargoInputForm.isOverCutOffTime;
  }

  get payloadIsFromRtc() {
    const cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    return this.isRtc || this.dataDetailRetryCargo.isFromRtc || cargoInputForm.isFromRebookingRTC
  }

  convertProduct(name: string) {
    return name
  }

  onDownloadCsvFailedStt(data: any) {
    this.downloadCsvFailedStt({
      fileName: "cargo_stt_failed.csv",
      listStt: data
    });
  }

  indexSelected = -1;
  onResetSelected() {
    this.indexSelected = -1;
  }
  get isActive(): boolean {
    return this.indexSelected === this.props?.index;
  }
  handleConfirmation() {
    if (this.statusUnavailable) return;

    this.indexSelected = this.props?.index;
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-confirmation-general",
        title: "<div class='text-sm font-semibold text-black-lp-200'>Proses kargo pesawat ini?</div>",
        message: this._generateConfirmationMessageElement(),
        onSubmit: this.onCheckEligible,
        onClose: () => {
          MainAppController.closeMessageModal();
          this.onResetSelected();
        },
        textSuccess: "Proses",
        textCancel: "Batal",
        customWidth: "fit-content",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        imageWidth: '32',
        imageHeight: '32',
      })
    );
  }

  _generateConfirmationMessageElement() {
    let route = `
    <div class="flex flex-row items-center">
      ${this.flightData.originAirportCode}
      <div class="text-gray-lp-800 flex flex-row items-center">
        &nbsp;-
        ${this.flightData.itineraries.filter((_itenerary, index) => this.flightData.itineraries.length - 1 !== index).map(itenerary => {
          return itenerary.destinationAirportCode;
        }).join(' - ')}&nbsp;-&nbsp;
      </div>${this.flightData.destinationAirportCode}
    </div>
`

    if (this.flightData.itineraries.length <= 1) {
      route = this.flightData.originAirportCode + ' - ' + this.flightData.destinationAirportCode;
    }

    return `
<div class="flex flex-col justify-center w-full gap-2">
  <div class="text-xs text-gray-lp-300">
    Pastikan kembali seluruh detail penerbangan sudah benar dan sesuai.
  </div>
  <div class="border border-gray-lp-1600 flex flex-row items-center text-gray-lp-300" style="border-radius: 10px; padding: 10px 0;">
    <div class="flex flex-col gap-1 border-r border-gray-lp-1600" style="padding: 0 10px;">
      <div class="text-gray-lp-800" style="min-width: 160px;">Estimasi keberangkatan</div>
      <div class="font-semibold text-base">${formatDateNormal(this.flightData.departureDate, "DD MMM YYYY, HH:mm")}</div>
    </div>
    <div class="flex flex-col gap-1 border-r border-gray-lp-1600" style="padding: 0 10px;">
      <div class="text-gray-lp-800" style="min-width: 140px;">Rute penerbangan</div>
      <div class="font-semibold text-base">${route}</div>
    </div>
    <div class="flex flex-col gap-1 " style="padding: 0 10px;">
      <div class="text-gray-lp-800" style="min-width: 160px;">Nomor penerbangan</div>
      <div class="font-semibold text-base">${this.flightData.itineraries[0].flightNo}</div>
    </div>
  </div>
</div>
`
  }

  _mapPayloadFlightPlanForECargo() {
    return this.flightData.itineraries.map((itinerary) => {
      return new FlightPlanForECargo(
        itinerary.dailyFlightNo.toString(),
        true,
        itinerary.flightNo,
        formatDateNormal(itinerary.departureDate, "YYYY-MM-DD"),
        itinerary.originAirportCode,
        itinerary.destinationAirportCode,
        itinerary.departureDate,
        itinerary.arrivalDate,
        itinerary.departureDate,
        +this.formBooking.thresholdTime
      );
    });
  }

  get isDimensionPlaneAutoV2(): boolean {
    const isRtcOrRebooking =
      this.isRTC && this.formBooking.cargoType === "plane";
    return Boolean(
      !flags.feature_hide_dimension_koli.isEnabled() &&
        this.isValidDimension &&
        (this.isPlaneAuto || isRtcOrRebooking)
    );
  }

  get cargoActualPiece() {
    return this.isDimensionPlaneAutoV2
      ? CargoController.dimensionPerKoliData.totalPieces
      : +this.formBooking.actualTotalSTTPieces;
  }

  get bagOrSttNo() {
    const cargoBagRaw = getDataSessionStorage("cargo-bag") || "[]";
    const cargoRaw = getDataSessionStorage("cargo") || "[]";

    const cargoBag = JSON.parse(cargoBagRaw);
    const cargo = JSON.parse(cargoRaw);

    const payloadBagNoOnly = cargoBag
      .map((item: any) => new AddBagOrStt(item.baggingNumber))
      .filter((item: any) => item != null);

    const payloadSttNoOnly = cargo
      .filter((item: any) => {
        const isAlreadyBagged = cargoBag.some((bag: any) =>
          JSON.stringify(bag).includes(item.sttNumber)
        );

        return !isAlreadyBagged;
      })
      .flatMap((item: any) => {
        if (item.sttDetails) {
          return item.sttDetails.map(
            (detail: any) => new AddBagOrStt(undefined, detail.sttNumber)
          );
        }
        return new AddBagOrStt(undefined, item.sttNumber);
      });

    return [...payloadBagNoOnly, ...payloadSttNoOnly];
  }

  async calculateVolume(calculateType = "") {
    await CargoController.calculateVolume(new CalculateVolumeApiRequest({
      calculateType,
      calculateRequest: new CalculateVolumeRequest({
        cargoType: this.formBooking.cargoType,
        chargeableWeightReweigh: this.chargeableWeight,
        currentGrossWeight: this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
        height: this.formBooking.actualDimension.height,
        length: this.formBooking.actualDimension.length,
        width: this.formBooking.actualDimension.width,
        totalPieces: this.formBooking.actualTotalSTTPieces,
        volumeWeightReweigh: this.parseNumber(this.totalNewCalculationVolumeWeights as any),
        divider: getConfigDimensionDivider(this.formBooking.cargoType),
        isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus),
        minVolumePerPiece: FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue()
      })
    }))
  }

  onCheckEligible() {
    const close = () => {
      const isRtc = new RegExp(/rtc/, "i").test(
        ReadyToCargoController.flowBooking
      );
      if (isRtc && !CargoController.sttResultFinal.length) {
        // redirect to list rtc
        CargoController.setProgressValue(-1);
        CargoController.setFillForm(false);
        CargoController.resetCargoData();
        ReadyToCargoController.setFlowBooking("");
        return;
      }

      // back to form scan
      const flowBooking = JSON.parse(
        getDataSessionStorage("flow-booking") || "{}"
      );
      if (flowBooking === "manual") {
        CargoController.setCargoType({});
      } else {
        ReadyToCargoController.setFlowBooking("rtc-edit");
        CargoController.setCargoOptions({ data: [] });
        CargoController.setIsEditReadyToCargo(true);
        CargoController.setIsFirstLandingEditRTC(true);
        CargoController.setShowCargoOptions(false);
      }

      CargoController.setProgressValue(0);
      CargoController.setDefaultFlightData();
      CargoController.setEditFlightData([]);
      CargoController.mappingCommodityOptions();
    };

    checkEligible(this.onCreateCargo, close);
  }

  async onCreateCargo() {
    await this.calculateVolume(CargoController.calculateVolumeData.calculateType);
    await this.$nextTick();
    MainAppController.closeMessageModal();

    const origin = this.flightData.originAirportCode;
    const destination = this.flightData.destinationAirportCode;

    const route = `${origin}-${destination}`;

    const dimensionV2 = CargoController.dimensionPerKoliData

    const resp = await CargoController.onCreateCargo({
      sequentialFlight: this.flightData.orderId,
      totalFlight: this.totalFlight,
      originAirportCode: this.payloadOriginAirportCode,
      destinationAirportCode: this.payloadDestinationAirportCode,
      estTotalCargoGrossweigth: this.validationPayloadTimbangUlang
        .estTotalCargoGrossweigth,
      estTotalCargoVolumeweight: this.validationPayloadTimbangUlang
        .estTotalCargoVolumeweight,
      partnerName: this.partnerName,
      partnerType: this.typeUser,
      cargoNo: this.formBooking.cargoNumber,
      cargoVehicleNo: this.formBooking.vehicleNumber,
      actualTotalCargoGrossweigth: this.validationPayloadTimbangUlang
        .actualTotalCargoGrossweigth,
      actualTotalCargoVolumeweight: this.validationPayloadTimbangUlang
        .actualTotalCargoVolumeweight,
      route: !route.includes("undefined") ? route : "", // from nGen
      totalStt: this.totalStt,
      totalPiece: this.totalPieces,
      cargoCommodity: this.formBooking.cargoCommodityCode,
      productCargo: this.formBooking.cargoProduct,
      cargoType: this.formBooking.cargoType,
      originCityCode: this.detailDistrict.cityCode,
      destinationCityCode: this.formBooking.destinationCityCode,
      departureDate: dateTimePayload(this.payloadDepartureDate),
      arrivalDate: dateTimePayload(this.payloadArrivalDate),
      bagOrStt: this.bagOrSttNo,
      isCargoPlaneManual:
        this.formBooking.cargoType === "plane" &&
        this.formBooking.cargoTypeStatus === "manual",
      cargoOverCutoffLimit: this.payloadOverCutOffLimit,
      cargoRtcTurnAuto: true,
      cargoActualPiece: this.cargoActualPiece,
      flightPlanForECargo: this._mapPayloadFlightPlanForECargo(),
      dimensions: this.validationPayloadTimbangUlang.dimensions,
      estDimension: this.formBooking.estDimension,
      actualDimension: this.validationPayloadTimbangUlang.actualDimension,
      isFromRtc: this.payloadIsFromRtc,
      rtcId: this.isRtc ? ReadyToCargoController.readyToCargoDetail.id : 0,
      nog: this.formBooking.nog,
      rebookingId: this.rcId,
      ngenCreatedAt: dateTimePayload(this.formBooking.ngenCreatedAt),
      shc: this.formBooking.shcCode,
      isFromScheduleCard: true,
      photoProof: this.formBooking.photoProof.filter((photo: any) => typeof photo === "string").filter(Boolean),
      cargoTotalChargeableWeight: this.totalSttChargeableWeight,
      cargoTotalCustomChargeableWeight: this.actualChargeableWeight,
      cargoTotalEstimateChargeableWeight: this.chargeableWeight,
      isNewCalculation: flags.feature_hide_dimension_koli.isEnabled(),
      calculateType: CargoController.calculateVolumeData.calculateType,
      isCargoDimensionOn: CargoController.isCargoDimensionOn
    }).catch(() => {
      this.showModalErrorBookingCargo();
    });
    this.onCreateResponse(resp);
  }
  get isUsePayloadTimbangUlang() {
    return (
      this.formBooking.cargoType !== "plane" || flags.feature_hide_dimension_koli.isEnabled()
    );
  }
  get rtcDetail() {
    return ReadyToCargoController.readyToCargoDetail;
  }
  get dimensionTimbangUlang() {
    const volumeWeight = Math.round(
      this.totalNewCalculationVolumeWeightsMaxFlag
    );
    
    const divider = getConfigDimensionDivider(this.formBooking.cargoType);

    const pieces = this.isRtc
      ? this.detail.totalPieces
      : CargoController.totalSttPieces;

    const length = 90;
    const width = 60;
    const height = Math.max(1, Math.floor(
      (volumeWeight * divider) / (length * width * pieces)
    ));

    return {
      length,
      width,
      height,
      pieces
    };
  }
  get validationPayloadTimbangUlang() {
    const actualTotalCargoGrossweigth = this.getActualCargoWeight(
      CargoController.dimensionPerKoliData.actualGrossWeight,
      this.formBooking.actualTotalCargoGrossWeight
    );

    if (this.isUsePayloadTimbangUlang) {
      return {
        actualDimension: this.formBooking.actualDimension,
        dimensions: this.mappingDetailPieces,
        actualTotalCargoGrossweigth,
        actualTotalCargoVolumeweight: Math.round(
          this.parseNumber(this.formBooking.actualTotalCargoVolumeWeight)
        ),
        estTotalCargoGrossweigth: CargoController.totalNewCalculationGrossWeights,
        estTotalCargoVolumeweight: this.totalNewCalculationVolumeWeights
      };
    }

    return {
      actualDimension: this.formBooking.actualDimension,
      dimensions: this.mappingDetailPieces,
      actualTotalCargoGrossweigth,
      actualTotalCargoVolumeweight: this.actualCargoVolumeWeightPayload,
      estTotalCargoGrossweigth: commaDecimalToDecimal(
        this.formBooking.estTotalCargoGrossWeight
      ),
      estTotalCargoVolumeweight: commaDecimalToDecimal(
        this.formBooking.estTotalCargoVolumeWeight
      )
    };
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get featureHideDimensionKoli(): boolean {
    return flags.feature_hide_dimension_koli.isEnabled();
  }
  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }
  get totalNewCalculationVolumeWeightsMaxFlag() {
    const min =
      this.formBooking.cargoType === "plane" && this.formBooking.cargoTypeStatus === "auto" && this.featureHideDimensionKoli
        ? Math.max(FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue(), 1)
        : 1;

    const volumeWeight = this.parseNumber(this.formBooking.actualTotalCargoVolumeWeight) || this.totalNewCalculationVolumeWeights;

    if (this.flowBooking === "rtc-process") return Math.max(this.totalNewCalculationVolumeWeights, min);
        
    return Math.max(volumeWeight, min);
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(this.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  get actualChargeableWeight() {
    if (this.isUsePayloadTimbangUlang) {
      return CargoController.calculateVolumeData.chargeableWeight;
    }

    return Math.max(
      1,
      this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
      this.parseNumber(this.formBooking.actualTotalCargoVolumeWeight)
    );
  }

  get totalSttChargeableWeight() {
    return CargoController.totalSttChargeableWeight;
  }

  get isEligibleCargoPlaneRTC() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus === "auto" &&
      (this.isRtc || (this.isRebooking && this.isFromRebookingRTC)) &&
      flags.feature_is_booking_cargo_v4.isEnabled()
    );
  }

  isEligibleCargoAWB(resp: any) {
    return resp.cargoNo.startsWith("FLIGHT") || resp.isCargoUsingAwb;
  }

  onCreateResponse(resp: any) {
    if (resp) {
      CargoController.resetScanFailedList();

      if (this.isEligibleCargoPlaneRTC) {
        this.showPopupTimeout(resp);
        return;
      } else if (this.isEligibleCargoAWB(resp)) {
        //error Ngen Non RTC
        // this.showModalMessageBookingOnProcess("Booking Kargo Sedang Diproses");
        this._openModalSuccess();
        this.bookingCargoGTM(this.eventName, "success");
      } else if (resp.totalSttFailed && !resp.totalSttSuccess) {
        CargoController.setSttFailed(resp.listSttFailed);
        this.countFailed = resp.totalSttFailed;
        this.showModalErrorBookingCargo();

        // GTM
        this.bookingCargoGTM(this.eventName, "failed");
        const gtmBookingCargoFailed = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: this.isPlaneAuto
        }).bookingCargoFailed;

        dataLayer(
          gtmBookingCargoFailed.eventName,
          gtmBookingCargoFailed.property,
          ["timestamp"]
        );
      } else if (resp.totalSttFailed && resp.totalSttSuccess) {
        this.countFailed = resp.totalSttFailed;
        this.countSuccess = resp.totalSttSuccess;
        // this._openModalPartial();
        this.showModalErrorBookingCargo();
        CargoController.setSttFailed(resp.listSttFailed);
        this.onPrint();
      } else {
        // GTM
        this.bookingCargoGTM(this.eventName, "success");
        const gtmBookingCargoSuccess = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: this.isPlaneAuto,
          gtmData: {
            cargoNumber: CargoController.cargoIdToGeneratePdf,
            flightNumber: this.formBooking.vehicleNumber
          }
        }).bookingCargoSuccess;

        dataLayer(
          gtmBookingCargoSuccess.eventName,
          gtmBookingCargoSuccess.property,
          ["timestamp"]
        );

        this._openModalSuccess();
        this.onPrint();
      }
    }
  }

  showPopupTimeout(resp: any) {
    const {
      bookingRequestId,
      cargoNo,
      totalSttFailed,
      totalSttSuccess,
      listSttFailed
    } = resp;

    if (bookingRequestId) {
      // Success case
      // this.handleSuccessResponse(bookingRequestId);
      this._openModalSuccess();
    } else if (cargoNo) {
      // Timeout case with cargoNo
      // this.handleTimeoutWithCargoNo();
      this.showModalErrorBookingCargo();
    } else if (totalSttFailed && !totalSttSuccess) {
      // Failed case
      this.handleFailedResponse(totalSttFailed, listSttFailed);
    } else if (totalSttFailed && totalSttSuccess) {
      // Partial success case
      this.handlePartialSuccessResponse(
        totalSttFailed,
        totalSttSuccess,
        listSttFailed
      );
    }
    // Close loading indicator
    MainAppController.closeLoading();
  }

  handleSuccessResponse(bookingRequestId: string) {
    this.showModalMessageBookingOnProcess(
      `Booking Kargo ${bookingRequestId} <br/> Sedang Diproses`
    );
    this.bookingCargoGTM(this.eventName, "success");
  }

  handleTimeoutWithCargoNo() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: "Booking Kargo Gagal Diproses nGen",
        message:
          "Lihat alasannya di halaman gagal booking. Cek & booking ulang",
        textSuccess: "OK",
        image: "image-modal-failed",
        onSubmit: () => {
          MainAppController.closeMessageModal();
          if (this.progress === 1) {
            CargoController.setIsFromCutOff(true);
            this.$router.push("booking-canceled");
          }
          this.$emit("leave-page", "/cargo/booking-canceled");
        }
      })
    );
  }

  handleFailedResponse(totalSttFailed: number, listSttFailed: any[]) {
    this.countFailed = totalSttFailed;
    CargoController.setSttFailed(listSttFailed);
    this.showModalErrorBookingCargo();
    this.bookingCargoGTM(this.eventName, "failed");

    const gtmBookingCargoFailed = gtmCargoData({
      type: this.formBooking.cargoType,
      isAuto: this.isPlaneAuto
    }).bookingCargoFailed;

    dataLayer(gtmBookingCargoFailed.eventName, gtmBookingCargoFailed.property, [
      "timestamp"
    ]);
  }

  handlePartialSuccessResponse(
    totalSttFailed: number,
    totalSttSuccess: number,
    listSttFailed: any[]
  ) {
    this.countFailed = totalSttFailed;
    this.countSuccess = totalSttSuccess;
    this.showModalErrorBookingCargo();
    CargoController.setSttFailed(listSttFailed);
    this.onPrint();
  }

  showModalMessageBookingOnProcess(title: string) {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title,
        message: "Anda akan mendapat notifikasi jika booking kargo berhasil",
        textSuccess: "OK",
        image: "illustration_waiting_process",
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.onCloseSuccess();
        }
      })
    );
  }

  bookingCargoGTM(eventName: any, result: string) {
    GTMBookingCargoEvent(eventName, {
      cargo_type: this.formBooking.cargoType,
      "3LC_origin": this.detailDistrict.cityCode,
      "3LC_destination": this.formBooking.destinationCityCode,
      booking_result: result,
      cargo_number: CargoController.cargoIdToGeneratePdf,
      timestamp_booking: this.timestampBooking,
      timestamp_get_result: new Date().getTime()
    });
  }

  showModalErrorBookingCargo() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        imageWidth: "32",
        imageHeight: "32",
        customWidth: "417px",
        title: "Pembuatan Gagal !",
        message: "Anda masih dapat menjadwalkan ulang kargo pesawat.",
        textSuccess: "Ok",
        image: "circle-error",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.onResetSelected();
          handleFailedBookingNavigation({
            router: this.$router,
            rcId: this.$route.query.rcId,
            cargoType: this.formBooking.cargoType,
            cargoTypeStatus: this.formBooking.cargoTypeStatus,
            flowBooking: this.flowBooking
          });
        }
      })
    );
  }

  _openModalPartial() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        customWidth: "480px",
        title: this.$t("Pembuatan Berhasil !"),
        message: this.$t("cargo.partialCreateMessage", {
          cargoNo: CargoController.cargoIdToGeneratePdf
        }),
        image: "image-modal-warning",
        textSuccess: "Download",
        textCancel: "OK",
        onSubmit: () => {
          this.onDownloadCsvFailedStt(CargoController.sttFailed);
        },
        onClose: () => {
          this.onCloseSuccess();
          MainAppController.closeMessageModal();
        }
      })
    );
  }

  onPrint() {
    const refs: any = this.$refs;
    if (this.withPrint || this.withPrintCutOff) {
      refs.print.printManifestV2(CargoController.cargoIdToGeneratePdf);

      // GTM
      const gtmBookingCargoSuccessPDF = gtmCargoData({
        type: this.formBooking.cargoType,
        isAuto: this.isPlaneAuto,
        gtmData: {
          cargoNumber: CargoController.cargoIdToGeneratePdf,
          flightNumber: this.formBooking.vehicleNumber
        }
      }).bookingCargoSuccessPDF;

      dataLayer(
        gtmBookingCargoSuccessPDF.eventName,
        gtmBookingCargoSuccessPDF.property,
        ["timestamp"]
      );
    }
    if (this.withPrintLabel || this.withPrintCutOffLabel) {
      refs.print.printData(CargoController.cargoIdToGeneratePdf, "label");

      // GTM
      const gtmBookingCargoSuccessLabel = gtmCargoData({
        type: this.formBooking.cargoType,
        isAuto: this.isPlaneAuto,
        gtmData: {
          cargoNumber: CargoController.cargoIdToGeneratePdf,
          flightNumber: this.formBooking.vehicleNumber
        }
      }).bookingCargoSuccessLabel;

      dataLayer(
        gtmBookingCargoSuccessLabel.eventName,
        gtmBookingCargoSuccessLabel.property,
        ["timestamp"]
      );
    }
  }

  _openModalSuccess() {
    const message = CargoController.cargoIdToGeneratePdf.includes("FLIGHT")
      ? this.$t("cargo.successCreateMessage", {
          cargoNo: CargoController.cargoIdToGeneratePdf
        })
      : this.$t("cargo.successCreateMessageV2", {
          cargoNo: CargoController.cargoIdToGeneratePdf
        });

    MainAppController.showMessageModal(
      new ModalMessageEntities({
        imageWidth: "32",
        imageHeight: "32",
        customWidth: "417px",
        title: this.$t("Pembuatan Berhasil !"),
        message,
        image: "badge-success",
        textSuccess: "OK",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        onSubmit: () => {
          this.onCloseSuccess();
          MainAppController.closeMessageModal();
          ReadyToCargoController.setFlowBooking("");
          CargoController.resetCargoData();
        }
      })
    );
  }

  setOpenSuccess(value: boolean) {
    CargoController.setOpenSuccess(value);
  }

  isAllowed: any = false;

  get todayTime() {
    return {
      hours: formatDate(new Date())
        ?.split(",")[1]
        ?.split(":")[0]
        ?.trim(),
      minutes: formatDate(new Date())
        ?.split(",")[1]
        ?.split(":")[1]
        ?.replace(/\bwib\b|\bwita\b|\bwit\b|\bgmt\b/gi, "")
        ?.trim()
    };
  }

  onCloseSuccess() {
    this.setOpenSuccess(false);
    this.isAllowed =
      +this.cutOffTime.hours < +this.todayTime.hours ||
      (+this.cutOffTime.hours === +this.todayTime.hours &&
        +this.cutOffTime.minutes < +this.todayTime.minutes);
    if (this.isEditCutoff && this.isAllowed) {
      CargoController.setIsFromCutOff(true);
      this.$router.push("/cargo");
    } else {
      if (this.progress === 1) {
        CargoController.setIsFromCutOff(true);
        this.$router.push("booking-success");
      }
    }

    // CargoController.setProgressValue(-1);
    this.onResetSelected();
  }

  loadingCheckAvailable = false;
  isAvailable = false;
  isCheckAvailable = false;
  error = false;

  get statusAvailable() {
    // status available baru valid setelah isCheckAvailable === true
    return this.isCheckAvailable && this.isAvailable;
  }

  get statusUnavailable() {
    return this.isCheckAvailable && !this.isAvailable;
  }

  async onCheckAvailable(e: MouseEvent) {
    try {
      e.stopPropagation(); // agar logic on click card tidak jalan

      CargoController.setDisableDelay(true); // delay disable untuk semua button cek
      setTimeout(() => {
        CargoController.setDisableDelay(false);
      }, 1000); // re enable button cek yang lain

      this.loadingCheckAvailable = true;
      this.error = false;

      const res = await CargoController.checkAvailable(
        new CheckAvailableRequest({
          idRow: this.props.index,
          actualTotalCargoGrossweight: commaDecimalToDecimal(
            this.formBooking.actualTotalCargoGrossWeight
          ),
          actualTotalCargoVolumeweight: commaDecimalToDecimal(
            this.formBooking.actualTotalCargoVolumeWeight
          ),
          office: this.formBooking.airportOrigin.office,
          participantId: this.formBooking.airportOrigin.participantId,
          cargoProductTypeCode: this.formBooking.cargoProduct,
          itineraries: this.flightData.itineraries
        })
      );
      this.isAvailable = res.isAvailable;
      this.isCheckAvailable = true;
    } catch (error) {
      this.error = true;
    } finally {
      this.loadingCheckAvailable = false;
    }
  }

  get disableDelay(): boolean {
    return CargoController.disableDelay;
  }

  get disabledCheckAvailable(): boolean {
    return this.disableDelay || this.loadingCheckAvailable || this.isAvailable;
  }

  get isNotSupportDg() {
    return this.flightData.itineraries.some((item) => item.isNotSupportDg);
  }
}
